import React from 'react'
import { SaveButton, Toolbar } from 'react-admin'
import { get, values } from 'lodash'
interface OptionProps {
  correct_option?: boolean
  reason?: string
}
interface QuestionProps {
  contents: Array<any>
}

export const CreateToolbar = (props: any) => {
  return (
    <Toolbar {...props}>
      <SaveButton
        label="salvar"
        redirect="list"
        submitOnEnter={true}
        transform={(data) => {
          const questions = get(data, 'grouper', [])
          const transform = questions.map((question: QuestionProps) => {
            values(question.contents).map((options: Array<OptionProps>) => {
              options.map((option: OptionProps) => {
                const correct = get(option, 'correct_option[0]', false)
                option.correct_option = false
                if (correct) {
                  option.correct_option = true
                  return
                }

                option.reason = ''
                return option
              })
            })

            return question
          })

          return { grouper: [...transform] }
        }}
      />
    </Toolbar>
  )
}
